import { action, observable } from 'mobx';
import { Entity } from '..';
import { ISerializable } from '../Entity';

export default class BannerButton extends Entity implements ISerializable {
    constructor(button?: Partial<BannerButton>) {
        super();
        if (button) this.update(button);
    }

    @observable text: string;
    @observable url: string;
    @observable openInNewWindow: boolean;
    @observable order: number;

    @action update(button: Partial<BannerButton>, allowUndefined = false) {
        super.update(button, allowUndefined);
    }

    toJson() {
        return {
            id: this.id?.startsWith('temp-') ? undefined : this.id,
            text: this.text,
            url: this.url,
            openInNewWindow: this.openInNewWindow,
            order: this.order,
        };
    }

    clone() {
        return new BannerButton({
            ...this
        });
    }

    static fromJson(json: any): BannerButton {
        return new BannerButton({
            ...json
        });
    }
}

